import type { JSX, PropsWithChildren } from "react";

type WrapProps = PropsWithChildren<{
	if: boolean;
	with: (children: React.ReactNode) => JSX.Element;
	elseWith?: (children: React.ReactNode) => JSX.Element;
}>;

export function Wrap({ if: condition, with: wrapper, children, elseWith }: WrapProps) {
	return condition ? wrapper(children) : (elseWith?.(children) ?? children);
}
